import { FC } from 'react';

import { IBannerItem } from 'api/website';

import Slider from 'components/common/Slider';
import AspectRatio, { AspectRatioWrapper } from 'components/common/AspectRatio';

import useScreen from 'hooks/useScreen';

import BannerSlide from './BannerSlide';

interface BannersSliderProps {
  width: number;
  bannerItems: IBannerItem[];
}

const BannersSlider: FC<BannersSliderProps> = ({ width, bannerItems }) => {
  const { isMobile } = useScreen();

  const showSpacing = isMobile && bannerItems?.length > 1;

  return (
    <AspectRatioWrapper spacing={0}>
      <AspectRatio spacing={0} widthPercent={width}>
        <Slider infinite autoplay arrows={false} centerMode={isMobile} centerPadding={showSpacing ? '30px' : '0px'}>
          {bannerItems.map((bannerItem) => (
            <BannerSlide key={bannerItem.id} bannerItem={bannerItem} showSpacing={showSpacing} />
          ))}
        </Slider>
      </AspectRatio>
    </AspectRatioWrapper>
  );
};

export default BannersSlider;
